module.exports = {
  customer: 'wokingham',
  environment: 'production',
  isBetterCare: true,
  yourMoney: false,
  jobsVolunteering: false,
  googleAnalyticsId: 'G-WCGNRX60ZL',
  robots: false,
  chatWidget: false,
  requirePostcode: false,

  app: {
    home: 'https://wokingham.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-wokingham.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-wokingham.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account.wokingham.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showAssessmentMutators: false,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
